var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6221 13.9593H15.5471C15.7346 13.9593 15.894 14.0249 16.0252 14.1562C16.1565 14.2874 16.2221 14.4468 16.2221 14.6343C16.2221 14.8218 16.1565 14.9812 16.0252 15.1124C15.894 15.2437 15.7346 15.3093 15.5471 15.3093H11.2721L12.6221 13.9593ZM4.70958 15.3093C4.60958 15.3093 4.51896 15.2906 4.43771 15.2531C4.35646 15.2156 4.28458 15.1656 4.22208 15.1031L2.21583 13.0968C1.95333 12.8343 1.81896 12.5187 1.81271 12.1499C1.80646 11.7812 1.94083 11.4593 2.21583 11.1843L10.2971 3.10305C10.5721 2.82805 10.8908 2.69055 11.2533 2.69055C11.6158 2.69055 11.9346 2.82805 12.2096 3.10305L15.8283 6.7218C16.0908 6.9843 16.2252 7.29993 16.2315 7.66868C16.2377 8.03743 16.1033 8.3593 15.8283 8.6343L9.35958 15.1031C9.29708 15.1656 9.22521 15.2156 9.14396 15.2531C9.06271 15.2906 8.97208 15.3093 8.87208 15.3093H4.70958ZM8.59083 13.9593L14.8721 7.67805L11.2533 4.0593L3.17208 12.1406L4.99083 13.9593H8.59083Z",
    fill: "#848B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFormat);
export default __webpack_public_path__ + "static/media/Clear Format.99483a7d83216f08a888925174507f2f.svg";
export { ForwardRef as ReactComponent };